export const pages = {
	'boltHome': { id: 'boltHome', page: 'home', getter: () => import(/* webpackChunkName: 'boltHome' */ 'components/bolt/home/home') },
	'boltPhotobooth': { id: 'boltPhotobooth', page: 'photobooth', getter: () => import(/* webpackChunkName: 'boltPhotobooth' */ 'components/bolt/photobooth/photobooth') }
};
export const sections = [
	{ id: 'boltSynopsis', getter: () => import(/* webpackChunkName: "boltSynopsis" */ 'components/bolt/synopsis/synopsis'), component: 'synopsis' }
];
export const sectionsWithParent = [

];
import VideoOverlayLoader from 'components/bolt/videoOverlayLoader/videoOverlayLoader';
export { VideoOverlayLoader };
